<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">{{gestoresLabel}}</span>
        <button class="action-button ml-2 my-1" (click)="invite()">Convidar Novo {{gestorLabel}}</button>
        <button class="action-button ml-2 my-1" (click)="goToListAccepted()">Visualizar Status dos Convites</button>
    </div>

    <div class="component-box container-fluid">
        <div class="row container-fluid pt-4">
            <div class="col-3">
                <span class="component-title">
                    {{gestoresCadastradosLabel}}
                </span>
            </div>
            <div class="col-9 text-right">
                <ul class="options-cadastro">
                    <li>
                        <div *ngIf="false" (click)="selectAllToDelete((selectAll = !selectAll))"
                            class="list-select mr-4 my-1" [ngClass]="{ active: blockCount > 0 }">
                            <button class="list-select" type="button">
                                <span>Selecionar tudo</span>
                            </button>
                        </div>
                    </li>
                    <li>
                        <div *ngIf="false" (click)="showDeleteAll(deleteallmodal)" class="list-select-delete ml-2 my-1"
                            [ngClass]="{ active: blockCount > 0 }">
                            <span class="list-select-delete">Excluir</span>
                        </div>
                    </li>
                    <li>
                        <div class="list-select mr-4 my-1">
                            <button type="button" class="list-select" (click)="showFilter(filtro)">
                                Aplicar filtro
                            </button>
                        </div>
                    </li>
                    <li>
                        <div class="list-select-search-input mr-2 my-1">
                            <input class="w-100" type="search" placeholder="Pesquise aqui..." #search
                                (change)="searchFilter(search.value)" />
                        </div>
                    </li>
                    <li>
                        <div class="list-filter-show-item ml-2 my-1">
                            Mostrar:
                            <select (change)="showItemChanged($event.target.value)">
                                <option [ngValue]="10" value="10" selected>10</option>
                                <option [ngValue]="25" value="25">25</option>
                                <option [ngValue]="50" value="50">50</option>
                                <option [ngValue]="100" value="100">100</option>
                            </select>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="table-overflow mx-2">
            <table class="list-table table table-striped">
                <thead class="list-table-head">
                    <th class="" (click)="sortOrder = !sortOrder;orderNome(cedenteGestorList, sortOrder)">
                        Nome
                    </th>
                    <th class="" (click)="sortOrder = !sortOrder;orderCPF(cedenteGestorList, sortOrder)">
                        CPF
                    </th>
                    <th class="" (click)="sortOrder = !sortOrder;orderStatus(cedenteGestorList, sortOrder)">
                        Status
                    </th>
                    <th></th>
                </thead>
                <tbody class="list-table-row">
                    <tr class=" list-table-cell"
                        *ngFor="let item of cedenteGestorList | paginate
                        : {
                            id: 'pagination1',
                            itemsPerPage: showItem,
                            currentPage: currentPage,
                            totalItems: totalItems
                        }"
                    >
                        <td class="clickable" (click)="item.toBlock = !item.toBlock; updateBlockCount()"
                            [class.font-weight-bold]="item.gestor.gestorGuid === currentUser.token.userReferenceId">
                            {{ item.gestor.pessoa.pessoaFisica.pessoaNome }}
                            <span *ngIf="item.gestor.gestorGuid ===currentUser.token.userReferenceId"
                                class="font-weight-bold mx-2">(você)</span>
                        </td>
                        <td class="clickable" (click)="item.toBlock = !item.toBlock; updateBlockCount()"
                            [class.font-weight-bold]="item.gestor.gestorGuid ===currentUser.token.userReferenceId">
                            {{ item.gestor.pessoa.documento.toString() | cpf }}
                        </td>
                        <td class="clickable" (click)="item.toBlock = !item.toBlock; updateBlockCount()"
                            [class.font-weight-bold]="item.gestor.gestorGuid === currentUser.token.userReferenceId">
                            {{ item.statusGestor }}
                        </td>
                        <td>
                            <div ngbDropdown class="d-inline-block menu-option" *ngIf="showContextMenu">
                                <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                    <img src="assets/icons/menu.png" />
                                </button>
                                <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                    <section class="custom-context-menu">
                                        <div *ngIf="!isResponsavel(item) || item.gestor.gestorGuid === currentUser.token.userReferenceId"
                                            ngbDropdownItem (click)="edit(item)">
                                            <img src="assets/icons/pencil-purple.png" class="mr-2" />
                                            Editar
                                        </div>
                                        <div ngbDropdownItem
                                            (click)="chagePhone(telefoneModal, item)"  *ngIf="item.gestor.gestorGuid === currentUser.token.userReferenceId">
                                            <img src="assets/icons/pencil-purple.png" class="mr-2" />
                                            Editar Telefone 
                                        </div>
                                        <div ngbDropdownItem
                                            *ngIf="!item.bloqueado && item.gestor.gestorGuid !== currentUser.token.userReferenceId"
                                            (click)="showBlock(blockModal, item)">
                                            <img src="assets/icons/garbage-purple.png" class="mr-2" />
                                            Bloquear
                                        </div>
                                        <div ngbDropdownItem *ngIf="item.bloqueado"
                                            (click)="showUnblock(unblockModal, item)">
                                            <img src="assets/icons/garbage-purple.png" class="mr-2" />
                                            Desbloquear
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="page-custom mt-2">
                <pagination-controls id="pagination1" (pageChange)="changePage($event)" responsive="true"
                    previousLabel="" nextLabel=""></pagination-controls>
            </div>
        </div>
    </div>
</div>

<!--Modal do Filtro-->
<ng-template #telefoneModal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Editar Telefone</h5>
                <p ngbAutofocus class="clean-modal-subtitle">
                    Digite o código enviado ao seu e-mail
                </p>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label" for="codigo">Código de confimação:</label>
                <input #codigo class="clean-filter-input" type="text" value="" />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label" for="telefone">Telefone:</label>
                <input #telefone class="clean-filter-input" type="text" [value]="telefoneGestor" [textMask]="{mask: telefoneCelularMask}" />
            </div>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button"
            (click)="editPhone(codigo.value, telefone.value); modal.dismiss('Close click')">
            Editar
        </button>
    </div>
</ng-template>

<!--Modal do Filtro-->
<ng-template #filtro let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar filtro</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label" for="nome">Nome:</label>
                <input #nome class="clean-filter-input" type="text" value="{{ filtroNome }}" />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label" for="cpf">CPF:</label>
                <input #cpf class="clean-filter-input" type="text" value="{{ filtroCPF }}" />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label" for="status">Status:</label>
                <input #status class="clean-filter-input" type="text" value="{{ filtroStatus }}" />
            </div>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button"
            (click)=" applyFilter(nome.value, cpf.value, status.value); modal.dismiss('Close click')">
            Aplicar
        </button>
    </div>
</ng-template>


<!--Modal do Deletar -->
<ng-template #deletemodal let-modal>
    <div class="container custom-modal">
        <div class="row mx-5">
            <div class="col-12 custom-modal-title my-5 text-center">
                <p>
                    Tem certeza que deseja excluir o
                    <br />
                    gestor:
                    {{ cedenteGestorToDelete["gestor"]["pessoa"]["pessoaFisica"]["pessoaNome"] }}?
                </p>
            </div>
            <div class="col-12 text-center my-2">
                <button class="custom-modal-button" type="button"
                    (click)=" delete(cedenteGestorToDelete); modal.dismiss('Close click')">
                    EXCLUIR
                </button>
            </div>
            <div class="col-12 text-center mt-2 mb-5">
                <button class="custom-modal-button-text" type="button" (click)="modal.dismiss('Close click')">
                    CANCELAR
                </button>
            </div>
        </div>
    </div>
</ng-template>

<!--Modal do Bloquear -->
<ng-template #blockModal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Bloquear Gestor</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <p class="col-12 clean-modal-subtitle" style="font-size: 20px;">
            Tem certeza que deseja bloquear o gestor:
            <span style="color:#313840; font-weight: bold;">{{ cedenteGestorToBlock["gestor"]["pessoa"]["pessoaFisica"]["pessoaNome"] }}?</span>
        </p>
        <div class="col-12 custom-filter-input-container">
            <label class="clean-filter-label" for="senhaGestor">Senha:</label>
            <input class="clean-filter-input" id="senhaGestor" type="password" #inSenha />
            <span class="legend" *ngIf="inSenhaInvalid">
                {{ inSenhaInvalidMessage }}
            </span>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-filter-button custom-filter-button-just" type="button"
            (click)="bloquear(cedenteGestorToBlock, inSenha.value)">
            Bloquear
        </button>
    </div>
</ng-template>

<!--Modal do Desbloquear -->
<ng-template #unblockModal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Desbloquear Gestor</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <p class="col-12 clean-modal-subtitle" style="font-size: 20px;">
            Tem certeza que deseja desbloquear o gestor:
            <span style="color:#313840; font-weight: bold;">{{ cedenteGestorToUnblock["gestor"]["pessoa"]["pessoaFisica"]["pessoaNome"] }}?</span>
        </p>
        <div class="col-12 custom-filter-input-container">
            <label class="clean-filter-label" for="senhaGestor">Senha:</label>
            <input class="clean-filter-input" id="senhaGestor" type="password" #inSenha />
            <span class="legend" *ngIf="inSenhaInvalid">
                {{ inSenhaInvalidMessage }}
            </span>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-filter-button custom-filter-button-just" type="button"
            (click)="desbloquear(cedenteGestorToUnblock, inSenha.value)">
            Desbloquear
        </button>
    </div>
</ng-template>

<!--Modal do Deletar Vários-->
<ng-template #deleteallmodal let-modal>
    <div class="container custom-modal">
        <div class="row mx-5">
            <div class="col-12 custom-modal-title my-5 text-center">
                <p>
                    Tem certeza que deseja excluir {{ blockCount }} Gestor(es)?
                </p>
            </div>
            <div class="col-12 text-center my-2">
                <button class="custom-modal-button" type="button" [disabled]="blockCount < 1"
                    (click)="deleteAllSelected(); modal.dismiss('Close click')">
                    EXCLUIR
                </button>
            </div>
            <div class="col-12 text-center mt-2 mb-5">
                <button class="custom-modal-button-text" type="button" (click)="modal.dismiss('Close click')">
                    CANCELAR
                </button>
            </div>
        </div>
    </div>
</ng-template>
